export const dnldChannelInsights = (builder) => ({
    dnldChannelInsights: builder.mutation({
        query: ({ loggedin_user_id, user_type_id, startDate, endDate }) => {
            return {
                url: '/downloadChanneloverview',
                method: 'GET',
                params: { loggedin_user_id, user_type_id, startDate, endDate  },
                headers: {
                    'Content-Type':  'text/csv', 
                },
                responseHandler: (response) => response.blob(),
            };
        },
    }),
});